
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/orders/new",
      function () {
        return require("private-next-pages/admin/orders/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/orders/new"])
      });
    }
  